import script from "./StockDeposit.vue?vue&type=script&setup=true&lang=ts"
export * from "./StockDeposit.vue?vue&type=script&setup=true&lang=ts"

import "./StockDeposit.vue?vue&type=style&index=0&id=8bd0d262&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd0d262"]])

export default __exports__